//import { v4 as uuidv4 } from 'uuid'; // npm install uuid

export class BaseEntityAttribute {
  private id: string | undefined;
  private name: string | undefined;
  private canUndock: boolean;
  private order: number | undefined;
  private canCollapse: boolean;
  protected mapEntityId: string | null;

  constructor(
    attributeName?: string,
    mapEntityId?: string,
    canUndock: boolean = false,
    canCollapse: boolean = false,
    order?: number
  ) {
    this.name = attributeName;
    this.canUndock = canUndock;
    this.order = order;
    this.canCollapse = canCollapse;
    this.mapEntityId = mapEntityId ?? null;
  }

  getId(): string | undefined {
    return this.id;
  }

  getMapEntityId(): string | null {
    return this.mapEntityId;
  }

  getCanUndock(): boolean {
    return this.canUndock;
  }

  getOrder(): number | undefined {
    return this.order;
  }

  getName(): string | undefined {
    return this.name;
  }

  setName(newName: string): void {
    this.name = newName;
  }

  getCanCollapse(): boolean {
    return this.canCollapse;
  }

  getVisualizer(): any {
  const directive = this.getDirective();
  // If it's a string, wrap if needed
  if (typeof directive === 'string') {
    if (this.canCollapse) {
      return `<attribute-wrapper title="${this.getName()}" id="attribute-wrapper-${this.getId()}" directive="${directive}"></attribute-wrapper>`;
    }
    return directive;
  }
  return directive;
}

  getDirective(): string {
    console.error("Error: Base visualizer directive doesn't exist.");
    return '';
  }
}
